export default __webpack_public_path__ + "static/media/delivery.d982d232.svg";